import React from "react";
// import blog1 from '../assets/img/.jpg';
import blog1 from "../../assets/images/blog1.jpg";
import blog2 from "../../assets/images/blog2.jpg";
import { Link } from "react-router-dom";

const Blog = () => {
  return (
    <div className="container-fluid blog p-0 mt-5">
      <div className="row g-0">
        <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.1s">
          <div className="h-100 d-flex flex-column justify-content-center bg-primari text-white py-5 px-4">
            <h3 className="mb-3 blog-heading">Chic & Classy Vibe</h3>
            <p>
              Girls’ blazers are making a huge comeback! From casual denim to
              tailored fits, discover how to style blazers with skirts, jeans,
              and shorts for a classy yet comfortable look.
            </p>
            <Link
              className="btn btn-light align-self-start text-uppercase fw-bold mt-2"
              to="/shop"
            >
              Read More <i className="bi bi-arrow-right"></i>
            </Link>
          </div>
        </div>

        <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.3s">
          <div className="h-80">
            <img
              className="img-fluid w-100 h-100"
              src={blog1}
              alt="Fashion Blog"
              style={{ objectFit: "cover" }}
            />
          </div>
        </div>

        <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.5s">
          <div className="h-100 d-flex flex-column justify-content-center bg-primari text-white py-5 px-4">
            <h3 className="mb-3 blog-heading">
             Men's Oversized T-Shirts
            </h3>
            <p>
              Oversized tees are trending this season. Pair them with cargos,
              denim, or joggers for a bold streetwear look that works for
              everyday fashion.
            </p>
            <Link
              className="btn btn-light align-self-start text-uppercase mt-2 fw-bold"
              to="/shop"
            >
              Read More <i className="bi bi-arrow-right"></i>
            </Link>
          </div>
        </div>

        <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.7s">
          <div className="h-100">
            <img
              className="img-fluid w-100 h-100"
              src={blog2}
              alt="Fashion Blog"
              style={{ objectFit: "cover" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
